import { createFileRoute } from "@tanstack/react-router";
import { SeoPage } from "@/components/SeoPage";
import { faqJsonLd } from "@/lib/seo-jsonld";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26, LAST_REVIEWED } from "@/lib/official-sources";

const faqs = [
  { q: "Vad är cateringtillstånd?", a: "Cateringtillstånd är ett stadigvarande serveringstillstånd för servering till slutna sällskap, t.ex. företagsevent, bröllop och konferenser." },
  { q: "Måste lokalen anmälas?", a: "Ja. Lokalen där cateringen sker ska anmälas till kommunen i förväg och godkännas ur brand- och ordningssynpunkt." },
  { q: "Krävs eget kök för cateringtillstånd?", a: "Nej. Från 1 juni 2026 har riksdagen tagit bort kravet på eget kök och varierat utbud av lagad mat. Matservering är inte längre ett villkor för att få cateringtillstånd – cateringföretaget får så klart fortsätta att leverera mat, men det är inte ett tillståndskrav." },
];

export const Route = createFileRoute("/serveringstillstand-catering")({
  component: () => (
    <SeoPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Guider", to: "/serveringstillstand-och-kunskapsprov" },
        { label: "För catering" },
      ]}
      title="Serveringstillstånd för catering"
      intro="Cateringtillstånd ger dig rätt att servera alkohol till slutna sällskap. Här är kraven, hur du ansöker och förbereder kunskapsprovet – uppdaterat för de nya reglerna 2026."
      lastReviewed={LAST_REVIEWED}
      sources={[SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26]}
      sections={[
        { h2: "Stadigvarande cateringtillstånd", body: "Ett stadigvarande cateringtillstånd ges till verksamhet som regelbundet serverar alkohol till slutna sällskap. Från 1 juni 2026 är kraven på eget kök och varierat matutbud borttagna . Mat är inte längre ett tillståndsvillkor – men cateringmodellen bygger i praktiken alltid på matleverans." },
        { h2: "Anmälan av lokal", body: "Varje lokal där cateringen sker måste anmälas till kommunen i förväg. Kommunen prövar lokalen och kan ställa krav på brandskydd och ordning." },
        { h2: "Krav på företaget", body: "Personlig och ekonomisk lämplighet, ordnad bokföring och godkänt kunskapsprov i alkohollagen för PBI." },
        { h2: "Kunskapsprovet", body: "Samma prov gäller som för restauranger. Med Alkoholprovet kan företagets ansvariga öva när som helst, var som helst." },
      ]}
      faqs={faqs}
      related={{
        title: "Relaterade sidor",
        links: [
          { to: "/serveringstillstand-och-kunskapsprov", label: "Hub – alla guider" },
          { to: "/nya-regler-serveringstillstand-2026", label: "Nya regler 2026" },
          { to: "/serveringstillstand-food-truck", label: "För food truck" },
          { to: "/serveringstillstand-restaurang", label: "För restaurang" },
          { to: "/tillfalligt-serveringstillstand", label: "Tillfälligt tillstånd" },
          { to: "/serveringstillstand-stockholm", label: "Serveringstillstånd Stockholm" },
          { to: "/serveringstillstand-goteborg", label: "Serveringstillstånd Göteborg" },
          { to: "/serveringstillstand-malmo", label: "Serveringstillstånd Malmö" },
          { to: "/foretag", label: "Företagslösning" },
          { to: "/kunskapsprov-alkohollagen", label: "Kunskapsprov i alkohollagen" },
        ],
      }}
    />
  ),
  head: () => ({
    meta: [
      { title: "Serveringstillstånd för catering – krav & ansökan" },
      { name: "description", content: "Cateringtillstånd: regler, lokalanmälan, krav på företag och kunskapsprov i alkohollagen. Uppdaterat 2026." },
      { property: "og:title", content: "Serveringstillstånd för catering" },
      { property: "og:description", content: "Krav, ansökan och kunskapsprov för catering." },
      { property: "og:url", content: "https://alkoholprovet.se/serveringstillstand-catering" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/serveringstillstand-catering" }],
    scripts: [
      faqJsonLd(faqs),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Guider", url: "https://alkoholprovet.se/serveringstillstand-och-kunskapsprov" },
        { label: "För catering", url: "https://alkoholprovet.se/serveringstillstand-catering" },
      ]),
    ],
  }),
});
